<section class="workspace-intro" *ngIf="data.sourceReports?.length">
  <div class="workspace-intro__eyebrow">Quellberichte</div>
  <div class="workspace-intro__summary">
    {{ data.sourceReports.length }} importierte Tagesberichte sind mit diesem Bautagebuch verknüpft.
  </div>
</section>

<app-bautagebuch-legacy-form></app-bautagebuch-legacy-form>
